import { AnalyticsProvider } from "@codat/analytics";
import config from "config";
import { createRoot } from "react-dom/client";
import "../node_modules/@codat/orchard-ui/dist/index.css";
import App from "./components/App";
import "./index.scss";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const container = document.getElementById("root");
const root = createRoot(container!);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      throwOnError: true,
    },
  },
});

root.render(
  <AnalyticsProvider
    config={{
      apiKey: config.AMPLITUDE_API_KEY,
      appName: "Link",
      mode: config.ENVIRONMENT === "Integration" ? "development" : "production",
    }}
  >
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <App />
    </QueryClientProvider>
  </AnalyticsProvider>
);
